import React, { useEffect, useState } from 'react';

export function GoogleMerchant() {
    const [data, setData] = useState(null);

    const renderRows = () => {
        if (!data.length) {
            return <tbody><tr><td colSpan="3">No products to show.</td></tr></tbody>;
        }
        return (
            <tbody>
                {data.map((d, index) =>
                    <tr key={index}>
                        <td>{d.id}</td>
                        <td>{d.name}</td>
                        <td>{d.description}</td>
                        <td>{d.link}</td>
                        <td>new</td>
                        <td>{d.price.toFixed(2)} CAD</td>
                        <td>in stock</td>
                        <td>{d.imageLink}</td>
                        <td></td>
                        <td>{d.id}</td>
                    </tr>
                )}
            </tbody>
        );
    };

    useEffect(() => {
        async function getData() {
            let response = await fetch(`/api/products/google-merchant`);
            let data = await response.json();
            setData(data);
        }

        getData();
    }, []);

    return (
        <div>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Google Merchant Data</h1>
            </div>
            <div className="card shadow mb-4">
                <div className="card-body">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>title</th>
                                <th>description</th>
                                <th>link</th>
                                <th>condition</th>
                                <th>price</th>
                                <th>availability</th>
                                <th>image link</th>
                                <th>gtin</th>
                                <th>mpn</th>
                            </tr>
                        </thead>
                        {data ? renderRows() :
                            <tbody>
                                <tr>
                                    <td colSpan="3">Loading...</td>
                                </tr>
                            </tbody>
                        }
                    </table>
                </div>
            </div>
        </div>
    );
}